export function shouldShowBubbleMenu({
	isEditable,
	hasEditorFocus,
	isUserSelection,
	isMenuFocused,
	isSelectionEmpty,
	isEmptyTextBlock,
	isInTable,
	isDividerSelection = false,
}: {
	isEditable: boolean
	hasEditorFocus: boolean
	isUserSelection: boolean
	isMenuFocused: boolean
	isSelectionEmpty: boolean
	isEmptyTextBlock: boolean
	isInTable: boolean
	isDividerSelection?: boolean
}) {
	if (!isEditable) {
		return false
	}

	// A blurred editor keeps its last selection, so without this every editor on
	// the page can float a toolbar over content the user is only reading.
	if (!hasEditorFocus && !isMenuFocused) {
		return false
	}

	// A selection the page set on its own, like opening a doc review, is not a
	// request to format anything.
	if (!isUserSelection && !isMenuFocused) {
		return false
	}

	// Clicking near a divider selects the whole node, and none of the
	// formatting buttons can do anything to it.
	if (isDividerSelection) {
		return false
	}

	if (isInTable) {
		return true
	}

	return !isSelectionEmpty && !isEmptyTextBlock
}
